import React, { useEffect, useRef } from "react";
import { SIGNOFF_METHOD_TYPE } from "../../../../../constant/constant";
import AddIcon from "@mui/icons-material/Add";
import { Grid, Typography } from "@mui/material";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import Checkbox from "../../../../../library/checkbox/checkbox";

const SignoffMethod = (props) => {
  const hiddenSignatureInput = useRef(null);

  useEffect(() => {
    if (
      props?.propsData?.getSwReference?.SwInspectionAcknowledgement &&
      props?.propsData?.certifyStatementIdValue
    ) {
      const findInspectionAcknowledgement =
        props?.propsData?.getSwReference?.SwInspectionAcknowledgement?.find(
          (item) => item.key === props?.propsData?.certifyStatementIdValue
        );
      props?.propsData?.setAcknowledgement(
        findInspectionAcknowledgement?.description ||
          findInspectionAcknowledgement?.value
      );
    }
  }, [
    props?.propsData?.getSwReference,
    props?.propsData?.certifyStatementIdValue,
  ]);

  return (
    <>
      <Grid container>
        {(parseInt(props?.propsData?.signoffMethodValue) ===
          SIGNOFF_METHOD_TYPE.CERTIFY_STATEMENT ||
          parseInt(props?.propsData?.signoffMethodValue) === 4) &&
          (props?.propsData?.acknowledgement ? (
            <Grid container spacing={4} wrap="wrap" my={1}>
              <Grid item xs={12}>
                {props?.propsData?.acknowledgement &&
                  props?.propsData?.checkedAcknowledgementError &&
                  !props?.propsData?.checkedAcknowledgement && (
                    <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                      Please check acknowledgement
                    </Typography>
                  )}
              </Grid>
              <Grid item>
                <Checkbox
                  checked={props?.propsData?.checkedAcknowledgement}
                  onChange={(e) => {
                    props?.propsData?.setCheckedAcknowledgement(
                      e.target.checked
                    );
                  }}
                  label=""
                />
              </Grid>
              <Grid item xs>
                <p className="defaultMsg">
                  {props?.propsData?.acknowledgement}
                </p>
              </Grid>
            </Grid>
          ) : (
            <></>
          ))}

        {(parseInt(props?.propsData?.signoffMethodValue) ===
          SIGNOFF_METHOD_TYPE.SIGNATURE ||
          parseInt(props?.propsData?.signoffMethodValue) === 4) && (
          <>
            {!props?.propsData?.isSignatureProfile && (
              <Grid item md={12} xs={12}>
                <FormLabels label="Add Inspector’s Signature" />

                <input
                  type="file"
                  ref={hiddenSignatureInput}
                  onChange={(event) => {
                    props?.propsData?.contractorsignatureUpload(event);
                  }}
                  style={{ display: "none" }}
                  accept="image/*"
                />
                <label
                  className="signatureBtn"
                  onClick={() => {
                    hiddenSignatureInput.current.click();
                    props?.propsData?.setImageCheck(true);
                  }}
                  htmlFor="actual-btn"
                >
                  <AddIcon /> Add Signature
                </label>
              </Grid>
            )}

            {props?.propsData?.signaureFileError && (
              <div className="error">
                {props?.propsData?.signaureFileErrorMessage}
              </div>
            )}

            <Grid item lg={12} xs={12} mt={1}>
              {!props?.propsData?.selectedContractorSignature &&
                props?.propsData?.signatureError && (
                  <p className="error">Please Add Signature</p>
                )}
            </Grid>

            <Grid item container mt={0} className="topHeaderProfile">
              <Grid item lg={6} xs={12} mt={2}>
                <Grid className="signatureImg">
                  {props?.propsData?.isSignatureProfile ? (
                    <img
                      className="borderSignatureImg"
                      src={props?.propsData?.isSignatureProfile}
                      alt=""
                    />
                  ) : (
                    <>
                      {props?.propsData?.selectedContractorSignature && (
                        <img
                          className="borderSignatureImg"
                          src={props?.propsData?.selectedContractorSignature}
                          alt=""
                        />
                      )}
                    </>
                  )}
                  {props?.propsData?.isSignatureProfile && (
                    <div className="overideLables">
                      <div className="formLabel">Authorized signature</div>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default SignoffMethod;
